import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: 0,
    init: false,
    profile: null,
    profile_pub: null,
    csrfinit: null,
    projects: [],
    factsheets: [],
    factsheet: null,
    createModal: false,
    explainerModal: false,
  },
  mutations: {
    profile (state, profile) {
      state.profile = profile
      state.init = true
    },
    profile_pub (state, profile_pub) {
      state.profile_pub = profile_pub
      state.init = true
    },
    status (state, status) {
      state.status = status
    },
    csrfinit (state, csrfinit) {
      state.csrfinit = csrfinit
    },
    projects (state, projects) {
      state.projects = projects
    },
    factsheets (state, factsheets) {
      state.factsheets = factsheets
    },
    factsheet (state, factsheet) {
      state.factsheet = factsheet
    },
    createModal (state, modalState) {
      state.createModal = modalState
    },
    explainerModal (state, modalState) {
      state.explainerModal = modalState
    },
  },
  actions: {

  }
})
